import { NoteEntityType, ResourceNoteEntityType } from './DynamoTypes';
import { PrimaryRecordResourceCategory } from './MedicalDataTypes';

export const isResourceNoteEntityType = (entityType: NoteEntityType): entityType is ResourceNoteEntityType =>
    entityType.endsWith('-resource');

export const extractResourceCategory = (entityType: ResourceNoteEntityType): PrimaryRecordResourceCategory =>
    entityType.replace('-resource', '') as PrimaryRecordResourceCategory;

export const resourceCategoryToNoteEntityType = (category: PrimaryRecordResourceCategory): ResourceNoteEntityType =>
    `${category}-resource`;

export type OrganizationNoteEntityType = Extract<NoteEntityType, 'organization' | 'organization-client-record'>;

/**
 * Whether notes of this entity type belong to an organization. Only these notes carry an `organizationId`; every
 * other entity type (profile, resource, care-team and user notes) never does.
 */
export const isOrganizationNoteEntityType = (entityType: NoteEntityType): entityType is OrganizationNoteEntityType =>
    entityType === 'organization' || entityType === 'organization-client-record';

/**
 * Stable opening of the AI-summary disclaimer prepended to system-generated clinical notes. Shared so the
 * note-service generator and the app's list preview agree on exactly what to write vs. skip. The full
 * disclaimer continues "... based on the attached original document from the {portal} portal. ..." — only this
 * lead-in is guaranteed constant, so detect on it (not the whole sentence, which names the source portal).
 */
export const AI_SUMMARY_DISCLAIMER_LEAD_IN = 'The following summary was generated by AI';
